import { Zap, TrendingUp, Clock } from "lucide-react";

export default function Promotions() {
  return (
    // Cadre de Luxe : Espacement généreux et fond neutre
    <div className="flex items-center justify-center min-h-screen px-4 pt-40 pb-20 font-sans bg-gray-50">
        
        {/* Conteneur de message Élite */}
        <div className="w-full max-w-xl p-10 text-center bg-white border border-gray-100 shadow-xl md:p-16 rounded-3xl">
            
            {/* Icône d'importance */}
            <TrendingUp size={64} className="text-[#f34141] mx-auto mb-6" strokeWidth={1.5} />
            
            {/* Titre Luxueux */}
            <h2 className="mb-4 text-4xl font-extrabold tracking-tight text-gray-900">
                Promotions Exclusives
            </h2>
            
            {/* Message de prestige */}
            <p className="mb-8 text-xl font-medium text-gray-600">
                La sélection des meilleures offres arrive très bientôt. 
                Préparez-vous à rehausser votre expérience d'achat.
            </p>
            
            {/* Éléments secondaires (pour l'attente) */}
            <div className="inline-flex items-center text-sm font-semibold text-[#f34141] bg-red-50 py-2 px-4 rounded-full">
                <Clock size={16} className="mr-2" />
                Disponible sous peu
            </div>

        </div>
    </div>
  );
}